var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-4"},[_c('image-field',{attrs:{"label":"","placeholder":"Page en lien","field":_vm.f.image,"record-types":[],"read-only":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }